<template lang="pug">
  main
    NavBarSolicitudes
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column
            h1.is-size-3 Nueva Solicitud
              | &nbsp
              router-link.a.button.is-dark.is-rounded.is-size-6(to="/Solicitudes")
                i.fas.fa-times
            br
        .columns.is-vcentered
          .column.is-5
            input#solIns.is-checkradio.is-black(type='radio', value='i' v-model='areaSol')
            label.is-size-6(for='solIns') Instrumentación
            input#solSis.is-checkradio.is-black(type='radio', value='s' v-model='areaSol')
            label.is-size-6(for='solSis') Sistemas
            input#solCons.is-checkradio.is-black(type='radio', value='c' v-model='areaSol' v-show="verConsumibles")
            label.is-size-6(for='solCons' v-show="verConsumibles") Consumibles
          .column.is-2.has-text-centered
            .field
              input#solServ.is-checkradio(type='checkbox' v-model='isServicio')
              label.is-size-6(for='solServ') Servicio
        .columns.is-vcentered
          .column.is-3
            .field
              label.label Equipo / Dispositivo / Consumible
              .control
                typeahead(:options="tiposShow" :optionSelect="itemData" :tema="typeTipos" v-model="itemSel")
          .column.is-2
            .field
              label.label Cantidad
              .control
                input.input.is-primary.is-rounded(
                  type='number', 
                  placeholder='Cantidad',
                  v-model="pedido.cantidad"
                )
          .column.is-2
            .field
              label.label No. Serie / Tag
                .control
                  input.input.is-primary.is-rounded(
                    type='text'
                    placeholder='Serie/Tag a reemplazar',
                    v-model="pedido.idEquipo"
                  )
        .columns.is-vcentered
          .column.is-2
            .field
              label.label Ubicación
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="ubicacionSel")
                    option(value="") Selecciona la ubicación
                    option(v-for="ubi in ubicaciones" :value="ubi.id" :key="ubi.id") {{ ubi.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-tools
          .column.is-2
            .field
              label.label Oficina
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="sitioSel")
                    option(value="") Selecciona el Sitio
                    option(v-for="data in oficinasSel" :value="data.id" :key="data.id") {{ data.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-tools
          .column.is-2
            .field
              label.label Prioridad
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="pedido.prioridad")
                    option(v-for="p in prioridades" :selected="pedido.prioridad === p.valor" :value="p.valor") {{ p.prioridad }}
                .icon.is-small.is-left
                  i.fas.fa-tools
          .column.is-6
            .field
              label.label Razón de la solicitud
              .control
                textarea.textarea.is-primary(placeholder='¿Para que solicita el equipo?' v-model="pedido.razon" rows=1)
        .columns(v-show="datosFaltantes.length > 0")
          .column.is-12
            .notification
              button.delete(@click="borrarNotificacion")
              .field.is-grouped.is-grouped-multiline
                .control(v-for="datosF in datosFaltantes")
                  .tags
                    span.tag.is-danger.is-light {{ datosF }}
        .columns
          .column.is-one-quarter
            a.button.is-primary.is-block.is-rounded(@click="checkForm" :disabled="isDisabled") Guardar
        .columns.column-blanco
</template>


<script>
  import NavBarSolicitudes from '@/components/solicitudes_Componentes/layout/NavBarSolicitudes.vue'
  import Typeahead from '@/components/inventario_Componentes/Typeahead.vue'
  import Loader from '@/components/shared/Loader.vue'
  import mySwitch from '@/components/checklist_Componentes/switch.vue'
  import { mapState } from 'vuex'
  import InventarioServices from '../../services/inventario/inventario'
  import usuariosServices from '../../services/usuarios/usuarios'
  import moment from 'moment'
  
  export default {
    name: 'NuevaSolicitud',
    components: { NavBarSolicitudes, Loader, mySwitch, Typeahead },
    data() {
      return {
        pedido: {
          razon: null,
          equipo: null,
          ubicacion: null,
          idSolicita: null,
          solicita: null,
          cantidad: 1,
          oficina: null,
          departamento: null,
          prioridad: 0,
          idEquipo: null
        },
        tipos: [],
        tiposShow: [],
        itemSel: {},
        itemData: {},
        typeTipos: 'tipos',
        usuarios_Solicita: {},
        ubicaciones: [
          { id: 'IRGE', nombre: 'IRGE'},
          { id: 'TPA', nombre: 'TPA'},
          { id: 'EB00', nombre: 'EB00'},
          { id: 'EB01', nombre: 'EB01'},
          { id: 'EB02', nombre: 'EB02'},
          { id: 'EB03', nombre: 'EB03'},
          { id: 'EB04', nombre: 'EB04'},
          { id: 'ERM', nombre: 'ERM'},
          { id: 'CORP', nombre: 'Corporativo'},
          { id: 'LPGD', nombre: 'Ducto'}
        ],
        oficinas: [
          { 'id': 'TPA-ALM', 'nombre': 'Almacén', 'source': 'TPA' },
          { 'id': 'TPA-ALS', 'nombre': 'Almacén Sist.', 'source': 'TPA' },
          { 'id': 'TPA-ADM', 'nombre': 'Of. Admin.', 'source': 'TPA' },
          { 'id': 'TPA-CC', 'nombre': 'Cuarto de Control', 'source': 'TPA' },
          { 'id': 'TPA-SERV', 'nombre': 'Servidores', 'source': 'TPA' },
          { 'id': 'TPA-IO', 'nombre': 'Cuarto de IOS', 'source': 'TPA' },
          { 'id': 'TPA-FAC', 'nombre': 'Facturación', 'source': 'TPA' },
          { 'id': 'TPA-BAS', 'nombre': 'Báscula', 'source': 'TPA' },
          { 'id': 'TPA-GER', 'nombre': 'Gerencia', 'source': 'TPA' },
          { 'id': 'TPA-MUE', 'nombre': 'Muelle', 'source': 'TPA' },
          { 'id': 'TPA-MANT', 'nombre': 'Subgerencia de Mntto.', 'source': 'TPA' },
          { 'id': 'TPA-TALL', 'nombre': 'Taller de Mntto.', 'source': 'TPA' },
          { 'id': 'TPA-SEG', 'nombre': 'Subgerencia de Seguridad', 'source': 'TPA' },
          { 'id': 'TPA-SADM', 'nombre': 'Subgerencia Administrativa', 'source': 'TPA' },
          { 'id': 'TPA-PROP', 'nombre': 'Of. Propangol', 'source': 'TPA' },
          { 'id': 'TPA-NIE', 'nombre': 'Of. Nieto', 'source': 'TPA' },
          { 'id': 'TPA-MOV', 'nombre': 'Of. Movenergy', 'source': 'TPA' },
          { 'id': 'TPA-SJ', 'nombre': 'Sala de Juntas', 'source': 'TPA' },
          { 'id': 'TPA-ACC', 'nombre': 'Accesos', 'source': 'TPA' },
          { 'id': 'TPA-VIG', 'nombre': 'Vigilancia', 'source': 'TPA' },
          { 'id': 'TPA-ESF', 'nombre': 'Esféricos', 'source': 'TPA' },
          { 'id': 'TPA-LLEN', 'nombre': 'Llenaderas', 'source': 'TPA' },
          { 'id': 'TPA-SJ2', 'nombre': 'Sala de Juntas 2', 'source': 'TPA' },
          { 'id': 'TPA-REC', 'nombre': 'Recepción', 'source': 'TPA' },
          { 'id': 'TPA-COM', 'nombre': 'Comedor', 'source': 'TPA' },
          { 'id': 'TPA-SALM', 'nombre': 'SubAlmacén', 'source': 'TPA' },
          { 'id': 'TPA-TRE', 'nombre': 'Área 300', 'source': 'TPA' },
          { 'id': 'IRGE-ALM', 'nombre': 'Almacén', 'source': 'IRGE' },
          { 'id': 'IRGE-ADM', 'nombre': 'Of. Admin.', 'source': 'IRGE' },
          { 'id': 'IRGE-CC', 'nombre': 'Cuarto de Control', 'source': 'IRGE' },
          { 'id': 'IRGE-FAC', 'nombre': 'Facturación', 'source': 'IRGE' },
          { 'id': 'IRGE-BAS', 'nombre': 'Báscula', 'source': 'IRGE' },
          { 'id': 'IRGE-GER', 'nombre': 'Gerencia', 'source': 'IRGE' },
          { 'id': 'IRGE-GADM', 'nombre': 'Gerencia Admn.', 'source': 'IRGE' },
          { 'id': 'IRGE-SJ', 'nombre': 'Sala de Juntas', 'source': 'IRGE' },
          { 'id': 'IRGE-SEG', 'nombre': 'Of. Seguridad', 'source': 'IRGE' },
          { 'id': 'IRGE-IOS', 'nombre': 'Cuarto de IOS', 'source': 'IRGE' },
          { 'id': 'IRGE-PEM', 'nombre': 'Of. Pemex', 'source': 'IRGE' },
          { 'id': 'IRGE-ACC', 'nombre': 'Accesos', 'source': 'IRGE' },
          { 'id': 'IRGE-VIG', 'nombre': 'Vigilancia', 'source': 'IRGE' },
          { 'id': 'IRGE-CE', 'nombre': 'Cuarto Eléctrico', 'source': 'IRGE' },
          { 'id': 'IRGE-REC', 'nombre': 'Recepción', 'source': 'IRGE' },
          { 'id': 'IRGE-OP', 'nombre': 'Operación', 'source': 'IRGE' },
          { 'id': 'IRGE-CCP', 'nombre': 'Cuarto Control Plus', 'source': 'IRGE' },
          { 'id': 'IRGE-VP', 'nombre': '23 Puntos', 'source': 'IRGE' },
          { 'id': 'IRGE-MOV', 'nombre': 'Movenergy', 'source': 'IRGE' },
          { 'id': 'IRGE-VIC', 'nombre': 'Vigilanca CUSAEM', 'source': 'IRGE' },
          { 'id': 'IRGE-OFE', 'nombre': 'Oficina Eléctrica', 'source': 'IRGE' },
          { 'id': 'EB04-ALG', 'nombre': 'Almacén S & I', 'source': 'EB04' },
          { 'id': 'EB04-CC', 'nombre': 'Cuarto de Control', 'source': 'EB04' },
          { 'id': 'EB04-ADM', 'nombre': 'Of. Admin.', 'source': 'EB04' },
          { 'id': 'EB04-GER', 'nombre': 'Gerencia', 'source': 'EB04' },
          { 'id': 'EB04-SIS', 'nombre': 'Sistemas', 'source': 'EB04' },
          { 'id': 'EB04-INS', 'nombre': 'Instrumentación', 'source': 'EB04' },
          { 'id': 'EB04-VIG', 'nombre': 'Vigilancia', 'source': 'EB04' },
          { 'id': 'EB04-SG', 'nombre': 'Sala de Juntas', 'source': 'EB04' },
          { 'id': 'EB04-TIA', 'nombre': 'Taller Inst/Aut', 'source': 'EB04' },
          { 'id': 'EB04-ALM', 'nombre': 'Almacén', 'source': 'EB04' },
          { 'id': 'EB03-CC', 'nombre': 'Cuarto de Control', 'source': 'EB03' },
          { 'id': 'EB03-ADM', 'nombre': 'Of. Admin.', 'source': 'EB03' },
          { 'id': 'EB03-VIG', 'nombre': 'Vigilancia', 'source': 'EB03' },
          { 'id': 'EB03-ARC', 'nombre': 'Archivo', 'source': 'EB03' },
          { 'id': 'EB03-COM', 'nombre': 'Comedor', 'source': 'EB03' },
          { 'id': 'EB03-REC', 'nombre': 'Recepción', 'source': 'EB03' },
          { 'id': 'EB03-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB03' },
          { 'id': 'EB03-SV', 'nombre': 'Servicios', 'source': 'EB03' },
          { 'id': 'EB03-TAL', 'nombre': 'Taller', 'source': 'EB03' },
          { 'id': 'EB03-ALM', 'nombre': 'Almacén', 'source': 'EB03' },
          { 'id': 'EB02-CC', 'nombre': 'Cuarto de Control', 'source': 'EB02' },
          { 'id': 'EB02-ADM', 'nombre': 'Of. Admin.', 'source': 'EB02' },
          { 'id': 'EB02-VIG', 'nombre': 'Vigilancia', 'source': 'EB02' },
          { 'id': 'EB02-ARC', 'nombre': 'Archivo', 'source': 'EB02' },
          { 'id': 'EB02-COM', 'nombre': 'Comedor', 'source': 'EB02' },
          { 'id': 'EB02-REC', 'nombre': 'Recepción', 'source': 'EB02' },
          { 'id': 'EB02-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB02' },
          { 'id': 'EB02-ALM', 'nombre': 'Almacén', 'source': 'EB02' },
          { 'id': 'EB01-CC', 'nombre': 'Cuarto de Control', 'source': 'EB01' },
          { 'id': 'EB01-ADM', 'nombre': 'Of. Admin.', 'source': 'EB01' },
          { 'id': 'EB01-VIG', 'nombre': 'Vigilancia', 'source': 'EB01' },
          { 'id': 'EB01-ARC', 'nombre': 'Archivo', 'source': 'EB01' },
          { 'id': 'EB01-COM', 'nombre': 'Comedor', 'source': 'EB01' },
          { 'id': 'EB01-REC', 'nombre': 'Recepción', 'source': 'EB01' },
          { 'id': 'EB01-SJ', 'nombre': 'Sala de Juntas', 'source': 'EB01' },
          { 'id': 'EB01-ALM', 'nombre': 'Almacén', 'source': 'EB01' },
          { 'id': 'EB00-CC', 'nombre': 'Cuarto de Control', 'source': 'EB00' },
          { 'id': 'EB00-ADM', 'nombre': 'Of. Admin.', 'source': 'EB00' },
          { 'id': 'EB00-VIG', 'nombre': 'Vigilancia', 'source': 'EB00' },
          { 'id': 'EB00-ALM', 'nombre': 'Almacén', 'source': 'EB00' },
          { 'id': 'EB00-ARC', 'nombre': 'Archivo', 'source': 'EB00' },
          { 'id': 'EB00-COM', 'nombre': 'Comedor', 'source': 'EB00' },
          { 'id': 'EB00-SV', 'nombre': 'Servicios', 'source': 'EB00' },
          { 'id': 'ERM-CC', 'nombre': 'Cuarto de Control', 'source': 'ERM' },
          { 'id': 'ERM-ADM', 'nombre': 'Of. Admin.', 'source': 'ERM' },
          { 'id': 'ERM-VIG', 'nombre': 'Vigilancia', 'source': 'ERM' },
          { 'id': 'ERM-ALM', 'nombre': 'Almacén', 'source': 'ERM' },
          { 'id': 'VALV-ADM', 'nombre': 'Gabinete', 'source': 'LPGD' },
          { 'id': 'CORP-DIR', 'nombre': 'Dirección', 'source': 'CORP' },
          { 'id': 'CORP-GG', 'nombre': 'Gerencia Gral.', 'source': 'CORP' },
          { 'id': 'CORP-GC', 'nombre': 'Gerencia de Contraloría', 'source': 'CORP' },
          { 'id': 'CORP-C', 'nombre': 'Contabilidad', 'source': 'CORP' },
          { 'id': 'CORP-CP', 'nombre': 'Cuentas por Pagar', 'source': 'CORP' },
          { 'id': 'CORP-F', 'nombre': 'Fiscal', 'source': 'CORP' },
          { 'id': 'CORP-SA', 'nombre': 'Seguimiento Amb.', 'source': 'CORP' },
          { 'id': 'CORP-GR', 'nombre': 'Gerencia de Reg.', 'source': 'CORP' },
          { 'id': 'CORP-ALM', 'nombre': 'Almacén', 'source': 'CORP' },
          { 'id': 'CORP-ALG', 'nombre': 'Almacén GIA', 'source': 'CORP' },
          { 'id': 'CORP-GIS', 'nombre': 'Gerencia Inst. y Sist.', 'source': 'CORP' },
          { 'id': 'CORP-SIT', 'nombre': 'Site', 'source': 'CORP' },
          { 'id': 'CORP-RH', 'nombre': 'Recursos Humanos', 'source': 'CORP' },
          { 'id': 'CORP-LEG', 'nombre': 'Legal', 'source': 'CORP' },
          { 'id': 'CORP-REC', 'nombre': 'Recepción', 'source': 'CORP' },
          { 'id': 'CORP-AUD', 'nombre': 'Auditoría', 'source': 'CORP' },
          { 'id': 'CORP-TES', 'nombre': 'Tesorería', 'source': 'CORP' },
          { 'id': 'CORP-GEN', 'nombre': 'General', 'source': 'CORP' },
          { 'id': 'LPGD-V1', 'nombre': 'Válvula 1', 'source': 'LPGD' },
          { 'id': 'LPGD-V2', 'nombre': 'Válvula 2', 'source': 'LPGD' },
          { 'id': 'LPGD-V3', 'nombre': 'Válvula 3', 'source': 'LPGD' },
          { 'id': 'LPGD-V4', 'nombre': 'Válvula 4', 'source': 'LPGD' },
          { 'id': 'LPGD-V5', 'nombre': 'Válvula 5', 'source': 'LPGD' },
          { 'id': 'LPGD-V6', 'nombre': 'Válvula 6', 'source': 'LPGD' },
          { 'id': 'LPGD-V7', 'nombre': 'Válvula 7', 'source': 'LPGD' },
          { 'id': 'LPGD-V8', 'nombre': 'Válvula 8', 'source': 'LPGD' },
          { 'id': 'LPGD-V9', 'nombre': 'Válvula 9', 'source': 'LPGD' },
          { 'id': 'LPGD-V10', 'nombre': 'Válvula 10', 'source': 'LPGD' },
          { 'id': 'LPGD-V11', 'nombre': 'Válvula 11', 'source': 'LPGD' },
          { 'id': 'LPGD-V12', 'nombre': 'Válvula 12', 'source': 'LPGD' },
          { 'id': 'LPGD-V13', 'nombre': 'Válvula 13', 'source': 'LPGD' },
          { 'id': 'LPGD-V14', 'nombre': 'Válvula 14', 'source': 'LPGD' },
          { 'id': 'LPGD-V15', 'nombre': 'Válvula 15', 'source': 'LPGD' },
          { 'id': 'LPGD-V16', 'nombre': 'Válvula 16', 'source': 'LPGD' },
          { 'id': 'LPGD-V17', 'nombre': 'Válvula 17', 'source': 'LPGD' },
          { 'id': 'LPGD-V18', 'nombre': 'Válvula 18', 'source': 'LPGD' },
          { 'id': 'LPGD-V19', 'nombre': 'Válvula 19', 'source': 'LPGD' },
          { 'id': 'LPGD-V20', 'nombre': 'Válvula 20', 'source': 'LPGD' },
          { 'id': 'LPGD-V21', 'nombre': 'Válvula 21', 'source': 'LPGD' },
          { 'id': 'LPGD-V22', 'nombre': 'Válvula 22', 'source': 'LPGD' },
          { 'id': 'LPGD-V23', 'nombre': 'Válvula 23', 'source': 'LPGD' },
          { 'id': 'LPGD-V24', 'nombre': 'Válvula 24', 'source': 'LPGD' },
          { 'id': 'LPGD-V25', 'nombre': 'Válvula 25', 'source': 'LPGD' },
          { 'id': 'LPGD-V26', 'nombre': 'Válvula 26', 'source': 'LPGD' },
          { 'id': 'LPGD-V1B', 'nombre': 'Válvula 1 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V2B', 'nombre': 'Válvula 2 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V3B', 'nombre': 'Válvula 3 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V4B', 'nombre': 'Válvula 4 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-V5B', 'nombre': 'Válvula 5 BIS', 'source': 'LPGD' },
          { 'id': 'LPGD-INT', 'nombre': 'Interconexión', 'source': 'LPGD' },
          { 'id': 'TPA-RV', 'nombre': 'Recuperador de vapores', 'source': 'TPA'},
          { 'id': 'TPA-PM', 'nombre': 'Paquete de Medición', 'source': 'TPA'},
          { 'id': 'TPA-BP', 'nombre': 'Bombas de Proceso', 'source': 'TPA'},
          { 'id': 'TPA-SISV', 'nombre': 'Sistema Vickers', 'source': 'TPA'},
          { 'id': 'TPA-SCI', 'nombre': 'Sist. Contra Incendio', 'source': 'TPA'},
          { 'id': 'TPA-CB', 'nombre': 'Cuarto de Baterias', 'source': 'TPA'},
          { 'id': 'EB00-BP', 'nombre': 'Bombas de Proceso', 'source': 'EB00'},
          { 'id': 'EB00-CB', 'nombre': 'Cuarto de Baterias', 'source': 'EB00'},
          { 'id': 'EB00-PM', 'nombre': 'Patín de Medición', 'source': 'EB00'},
          { 'id': 'EB00-TD', 'nombre': 'Trampa de Diablos', 'source': 'EB00'},
          { 'id': 'EB00-TR', 'nombre': 'Tren de Regulación', 'source': 'EB00'},
          { 'id': 'ERM-PM', 'nombre': 'Patín de Medición', 'source': 'ERM'},
          { 'id': 'ERM-SAL', 'nombre': 'Salida IRGE', 'source': 'ERM'},
          { 'id': 'ERM-TD', 'nombre': 'Trampa de Diablos', 'source': 'ERM'},
          { 'id': 'ERM-TP', 'nombre': 'Tanque Pulmón', 'source': 'ERM'},
          { 'id': 'ERM-TPRG', 'nombre': 'Tanque de Purga', 'source': 'ERM'},
          { 'id': 'ERM-TR', 'nombre': 'Tren de Regulación', 'source': 'ERM'},
          { 'id': 'ERM-JEF', 'nombre': 'Jefatura', 'source': 'ERM'},
          { 'id': 'ERM-COM', 'nombre': 'Comedor', 'source': 'ERM'},
          { 'id': 'ERM-CEL', 'nombre': 'Cuarto Eléctrico', 'source': 'ERM'},
          { 'id': 'EB04-BP', 'nombre': 'Bombas de Proceso', 'source': 'EB04'},
          { 'id': 'EB04-CAB', 'nombre': 'Cabezales', 'source': 'EB04'},
          { 'id': 'EB04-CB', 'nombre': 'Cobertizo de Bombas', 'source': 'EB04'},
          { 'id': 'EB04-COC', 'nombre': 'Cocina', 'source': 'EB04'},
          { 'id': 'EB04-CTE', 'nombre': 'Cuarto Eléctrico', 'source': 'EB04'},
          { 'id': 'EB04-GEN', 'nombre': 'Generadores', 'source': 'EB04'},
          { 'id': 'EB04-PM', 'nombre': 'Patín de Medición', 'source': 'EB04'},
          { 'id': 'EB04-RP', 'nombre': 'Residuos Peligrosos', 'source': 'EB04'},
          { 'id': 'EB04-TALL', 'nombre': 'Taller y Almacén', 'source': 'EB04'},
          { 'id': 'EB04-TD', 'nombre': 'Trampa de Diablos', 'source': 'EB04'},
          { 'id': 'EB04-TORG', 'nombre': 'Tanque de Purga', 'source': 'EB04'},
          { 'id': 'EB04-TR', 'nombre': 'Tren de Regulación', 'source': 'EB04'},
          { 'id': 'EB04-TRA', 'nombre': 'Transformador', 'source': 'EB04'},
          { 'id': 'IRGE-BOM', 'nombre': 'Bombas LPG', 'source': 'IRGE'},
          { 'id': 'IRGE-BP', 'nombre': 'Bombas de Proceso', 'source': 'IRGE'},
          { 'id': 'IRGE-CB', 'nombre': 'Cuarto de Bombas', 'source': 'IRGE'},
          { 'id': 'IRGE-CCM', 'nombre': 'CCM', 'source': 'IRGE'},
          { 'id': 'IRGE-CI', 'nombre': 'Red C.I.', 'source': 'IRGE'},
          { 'id': 'IRGE-COMP', 'nombre': 'Area de Compresores', 'source': 'IRGE'},
          { 'id': 'IRGE-CONT', 'nombre': 'Contabilidad', 'source': 'IRGE'},
          { 'id': 'IRGE-CUB', 'nombre': 'Cubeta', 'source': 'IRGE'},
          { 'id': 'IRGE-ESF', 'nombre': 'Esferas', 'source': 'IRGE'},
          { 'id': 'IRGE-LLEN', 'nombre': 'Llenaderas', 'source': 'IRGE'},
          { 'id': 'IRGE-MANT', 'nombre': 'Of. Mantenimiento', 'source': 'IRGE'},
          { 'id': 'IRGE-PROP', 'nombre': 'Of. Propangol', 'source': 'IRGE'},
          { 'id': 'IRGE-TA', 'nombre': 'Tanque de Agua', 'source': 'IRGE'},
          { 'id': 'IRGE-TD', 'nombre': 'Trampa de Diablos', 'source': 'IRGE'},
          { 'id': 'IRGE-TP', 'nombre': 'Tanque Pulmón', 'source': 'IRGE'},
          { 'id': 'IRGE-TR', 'nombre': 'Tren de Regulación', 'source': 'IRGE'},
          { 'id': 'IRGE-TRA', 'nombre': 'Area de Trasiegos', 'source': 'IRGE'},
          { 'id': 'IRGE-TALL', 'nombre': 'Taller', 'source': 'IRGE'},
        ],
        oficinasSel: [],
        departamentos: [
          { 'id': 'TPA-G', 'nombre': 'Gerencia', 'source': 'TPA' },
          { 'id': 'TPA-M', 'nombre': 'Mantenimiento', 'source': 'TPA' },
          { 'id': 'TPA-O', 'nombre': 'Operaciones', 'source': 'TPA' },
          { 'id': 'TPA-S', 'nombre': 'Seguridad', 'source': 'TPA' },
          { 'id': 'TPA-Si', 'nombre': 'Sistemas', 'source': 'TPA' },
          { 'id': 'TPA-I', 'nombre': 'Instrumentación', 'source': 'TPA' },
          { 'id': 'TPA-A', 'nombre': 'Administración', 'source': 'TPA' },
          
          { 'id': 'IRGE-G', 'nombre': 'Gerencia', 'source': 'IRGE' },
          { 'id': 'IRGE-M', 'nombre': 'Mantenimiento', 'source': 'IRGE' },
          { 'id': 'IRGE-O', 'nombre': 'Operaciones', 'source': 'IRGE' },
          { 'id': 'IRGE-S', 'nombre': 'Seguridad', 'source': 'IRGE' },
          { 'id': 'IRGE-Si', 'nombre': 'Sistemas', 'source': 'IRGE' },
          { 'id': 'IRGE-I', 'nombre': 'Instrumentación', 'source': 'IRGE' },
          { 'id': 'IRGE-A', 'nombre': 'Administración', 'source': 'IRGE' },
          { 'id': 'EB00-O', 'nombre': 'Operaciones', 'source': 'EB00' },
          { 'id': 'EB01-O', 'nombre': 'Operaciones', 'source': 'EB01' },
          { 'id': 'EB02-O', 'nombre': 'Operaciones', 'source': 'EB02' },
          { 'id': 'EB03-O', 'nombre': 'Operaciones', 'source': 'EB03' },
          { 'id': 'EB04-O', 'nombre': 'Operaciones', 'source': 'EB04' },
          { 'id': 'EB04-Si', 'nombre': 'Sistemas', 'source': 'EB04' },
          { 'id': 'EB04-I', 'nombre': 'Instrumentación', 'source': 'EB04' },
          { 'id': 'EB04-A', 'nombre': 'Administración', 'source': 'EB04' },
          { 'id': 'EB04-G', 'nombre': 'Gerencia', 'source': 'EB04' },
          { 'id': 'ERM-O', 'nombre': 'Operaciones', 'source': 'ERM' },
          { 'id': 'LPGD-O', 'nombre': 'Operaciones', 'source': 'LPGD' },
          { 'id': 'CORP-GG', 'nombre': 'Gerencia Gral.', 'source': 'CORP' },
          { 'id': 'CORP-SA', 'nombre': 'Seguimiento Amb.', 'source': 'CORP' },
          { 'id': 'CORP-GR', 'nombre': 'Gerencia de Reg.', 'source': 'CORP' },
          { 'id': 'CORP-GC', 'nombre': 'Gerencia de Contraloría', 'source': 'CORP' },
          { 'id': 'CORP-C', 'nombre': 'Contabilidad', 'source': 'CORP' },
          { 'id': 'CORP-CP', 'nombre': 'Cuentas por Pagar', 'source': 'CORP' },
          { 'id': 'CORP-F', 'nombre': 'Fiscal', 'source': 'CORP' },
          { 'id': 'CORP-DIR', 'nombre': 'Dirección', 'source': 'CORP' }
        ],
        departamentosSel: [],
        isLoading: true,
        sitioSel: null,
        ubicacionSel: null,
        sitios: {},
        checado: true,
        prioridades: [
          { valor: 0, prioridad: 'Baja'},
          { valor: 1, prioridad: 'Normal'},
          { valor: 2, prioridad: 'Alta'}
        ],
        areaSol: 'i',
        isServicio: false,
        isDisabled: false,
        servicioSel: {},
        itemServicio: {},
        typeServicios: 'services',
        verConsumibles: true,
        datosFaltantes: []
      }
    },
    watch: {
      sitioSel() {
        if (this.sitioSel) {
          this.pedido.oficina = this.sitioSel
        } else {
          this.pedido.oficina = null
        }
      },
      itemSel() {
        if (this.itemSel) {
          this.pedido.equipo = this.itemSel.text
        } else {
          this.pedido.equipo = null
        }
      },
      ubicacionSel() {
        if (this.ubicacionSel) {
          this.oficinasSel = this.oficinas.filter((ofi) => ofi.source === this.ubicacionSel)
        } 
      },

      'pedido.cantidad'() {
        if (this.pedido.cantidad <= 1) {
          this.pedido.cantidad = 1
        }
      },
      areaSol() {
        
        
        switch (true) {
          case this.areaSol === 'c':
            this.tiposShow = []
            this.tiposShow = this.tipos.filter( cat => cat.isConsumible === 1)
            this.isServicio = false
            break
          case this.areaSol === 's':
            this.tiposShow = []
            this.tiposShow = this.tipos.filter( cat => cat.area === 's' && cat.isConsumible === 0)
            this.isServicio = false
            break
          case this.areaSol === 'i':
            this.tiposShow = []
            this.tiposShow = this.tipos.filter( cat => cat.area === 'i' && cat.isConsumible === 0)
            this.isServicio = false
            break
          case this.areaSol === null:
            
            break
        }
      },
      isServicio () {
        if (this.isServicio) {
          this.areaSol = null
          this.tiposShow = []
          this.tiposShow = this.tipos.filter( cat => cat.isServicio === 1 )
        }
      }
    },
    methods: {
      iniciarComponente () {
        this.isLoading = true
        this.pedido.ubicacion = this.userLogin.ubicacion
        this.pedido.idSolicita = this.userLogin.id
        this.pedido.solicita = this.userLogin.nombre
        //this.areaSol = this.area_solicitud
        if (this.userLogin.ubicacion === 'LPG_DUCTO') {
          this.departamentosSel = this.departamentos.filter( dep => dep.source === 'EB04')
          this.oficinasSel = this.oficinas.filter( dep => dep.source === 'EB04')
        } else {
          this.departamentosSel = this.departamentos.filter( dep => dep.source === this.pedido.ubicacion)
          this.oficinasSel = this.oficinas.filter( dep => dep.source === this.pedido.ubicacion)
        }
        this.usuarios_Solicita = this.userLogin
        this.pedido.departamento = this.userLogin.departamento
        this.obtenerTipos()
      },

      checkForm(){
        this.datosFaltantes = []
        if (Object.keys(this.itemSel).length > 0 && this.ubicacionSel && this.sitioSel && this.pedido.razon) {
          console.log('Completo')
          this.saveSolicitud()
        } else {
          console.log('Incompleto')

          if (Object.keys(this.itemSel).length == 0) {
            this.datosFaltantes.push('El equipo es requerido.')
          }

          if (!this.ubicacionSel) {
            this.datosFaltantes.push('La ubicación es requerida.')
          }

          if (!this.sitioSel) {
            this.datosFaltantes.push('El oficina es requerida.')
          }

          if (!this.pedido.razon) {
            this.datosFaltantes.push('La razón de la solicitud es requerida.')
          }

        }
      },

      saveSolicitud () {
          this.isLoading = true
          let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
          let areaInt = 0
          let estInt = 0

          switch (this.areaSol) {
            case 'i':
              areaInt = 1  
              break
            case 'c':
              areaInt = 2
              break
            case 's':
              areaInt = 3  
              break
          
            default:
              break
          }

          switch (this.userLogin.categoria) {
            case 0:
              console.log('G')
              estInt = 3
              break
            case 1:
              console.log('AG')
              this.userLogin.departamento === 6 ? estInt = 3 : estInt = 2
              break
            case 2:
              console.log('JA')
              this.userLogin.departamento === 1 || this.userLogin.departamento === 3 ? estInt = 4 : estInt = 2
              break
            case 3:
              console.log('U')
              this.userLogin.departamento === 1 || this.userLogin.departamento === 3 ? estInt = 3 : estInt = 1
              break
          }
          let isServ = 0
          this.isServicio ? isServ = 1 : isServ = 0
          if (this.isServicio) {
            switch (this.itemSel.area) {
              case 'i':
                areaInt = 1  
                break
              case 'c':
                areaInt = 2
                break
              case 's':
                areaInt = 3  
                break
            }
          }
          InventarioServices.addSolicitud(fechaReg, this.pedido.equipo, this.itemSel.id_cat, this.itemSel.categoria, this.itemSel.id_sub, this.itemSel.subcategoria, this.pedido.razon, this.pedido.cantidad, this.userLogin.ubicacion, areaInt, this.userLogin.departamento, this.pedido.oficina, this.userLogin.id, this.userLogin.nombre, this.pedido.prioridad, isServ, estInt)
            .then( res => {
              console.log(res)
              let icon = ''
              res.success ? icon = 'done' : 'ban'
              this.displayToast(res.respuesta, icon, 'OK')
              res.success 
                ? this.$router.push('/Solicitudes')
                : this.isLoading = false
            })
            .catch( (e) => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
            }) 
        
        
      },
      obtenerTipos () {
        InventarioServices.getCats_Subcats()
          .then(res => {
            console.log(res)
            this.tipos = res.map(this.convetirArticulos)
            this.tiposShow = this.tipos.filter( tip => tip.area === this.areaSol)
            this.isLoading = false
          })
      },
      convetirArticulos(item) {
        let compl = ''
        if (item.subcategoria !== '') {
          compl = ` - ${item.subcategoria}`
        }

        return {
          ...item,
          text: `${item.categoria}${compl}`,
          isConsumible: parseInt(item.isConsumible),
          isServicio: parseInt(item.isServicio),
          responsiva: parseInt(item.responsiva),
          id_cat: item.id,
          id_sub: item.id_sub
        }
      },
      getTipo: function (id) {
        let result;
        let type = this.tipos.filter(tipo => tipo.id === id)
        let tipoEnc = type[0]
        if (tipoEnc.subcategoria === '') {
          result = tipoEnc.categoria
        } else {
          result = `${tipoEnc.categoria} (${tipoEnc.subcategoria})`
        }
        return result
      },
      borrarNotificacion() {
        this.datosFaltantes = []
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, {
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      }
    },
    created () {
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push('/')
      }
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'area_solicitud'])
    }
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/solicitudes_Componentes/NuevaSolicitud.vue